var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgQuestion = function SvgQuestion(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 19 19",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "question-fill")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u304A\\u554F\\u3044\\u5408\\u308F\\u305Bstaff-copy",
    transform: "translate(-5.000000, -464.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-fill",
    transform: "translate(5.000000, 464.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 19 0 19 19 0 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,18 C4.80545,18 1,14.19455 1,9.5 C1,4.80545 4.80545,1 9.5,1 C14.19455,1 18,4.80545 18,9.5 C18,14.19455 14.19455,18 9.5,18 Z M8.65,12.05 L8.65,13.75 L10.35,13.75 L10.35,12.05 L8.65,12.05 Z M10.35,10.65175 C11.7618626,10.2262194 12.6493835,8.83114808 12.436524,7.37199659 C12.2236646,5.91284509 10.9745889,4.82945822 9.5,4.825 C8.08183891,4.82489191 6.86064032,5.82554197 6.58195,7.21605 L8.24965,7.5501 C8.38128922,6.8914983 9.00126578,6.4479445 9.66709609,6.53600746 C10.3329264,6.62407042 10.8162735,7.21355023 10.7721678,7.88372913 C10.728062,8.55390803 10.1716287,9.07495784 9.5,9.075 C9.03055796,9.075 8.65,9.45555796 8.65,9.925 L8.65,11.2 L10.35,11.2 L10.35,10.65175 Z",
    id: "Shape",
    fill: "#F0396D",
    fillRule: "nonzero"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuestion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/question.9d652c4d.svg";
export { ForwardRef as ReactComponent };